var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99757 3.399V2.20172C4.99757 1.61779 5.22954 1.05777 5.64244 0.644868C6.05534 0.231966 6.61535 0 7.19929 0H10.5984C11.1824 0 11.7424 0.231966 12.1553 0.644868C12.5682 1.05777 12.8001 1.61779 12.8001 2.20172V3.399H16.5483C16.8256 3.399 17.0504 3.62381 17.0504 3.90114C17.0504 4.17847 16.8256 4.40329 16.5483 4.40329H15.3495V15.7983C15.3495 16.3822 15.1175 16.9422 14.7046 17.3551C14.2917 17.768 13.7317 18 13.1478 18H4.64993C4.066 18 3.50598 17.768 3.09308 17.3551C2.68018 16.9422 2.44821 16.3822 2.44821 15.7983V4.40329H1.25215C0.974818 4.40329 0.75 4.17847 0.75 3.90114C0.75 3.62381 0.974818 3.399 1.25215 3.399H4.99757ZM6.35258 1.35501C6.57714 1.13045 6.88171 1.00429 7.19929 1.00429H10.5984C10.916 1.00429 11.2206 1.13045 11.4451 1.35501C11.6697 1.57957 11.7959 1.88414 11.7959 2.20172V3.399H6.00186V2.20172C6.00186 1.88414 6.12802 1.57957 6.35258 1.35501ZM6.67529 8.0554C6.67529 7.71298 6.93297 7.42502 7.26315 7.42502C7.59333 7.42502 7.85101 7.71298 7.85101 8.0554V13.6946C7.85101 14.0371 7.59333 14.325 7.26315 14.325C6.93297 14.325 6.67529 14.0371 6.67529 13.6946V8.0554ZM10.1496 8.0554C10.1496 7.71298 10.4073 7.42502 10.7374 7.42502C11.0676 7.42502 11.3253 7.71298 11.3253 8.0554V13.6946C11.3253 14.0371 11.0676 14.325 10.7374 14.325C10.4073 14.325 10.1496 14.0371 10.1496 13.6946V8.0554Z",
    fill: "#F64747"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete.4194ee69059cfa95b89ca946c35c0fb0.svg";